(() => {
  if (customElements.get('xtra-coupon-strip')) return;
  customElements.define('xtra-coupon-strip', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.prices = JSON.parse(this.querySelector('[data-coupon-variants]').textContent);
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.copy(), options);
      // The existing bundle picker dispatches this event before its section refresh.
      const scope = this.closest('.product-info') || this.closest('.shopify-section');
      scope?.addEventListener('variant:change', event => {
        const price = this.prices[String(event.detail?.variant?.id)];
        this.hidden = !price;
        if (price && this.dataset.currency === 'USD') {
          this.querySelector('[data-coupon-price]').textContent = price;
        }
      }, options);
      if (this.dataset.currency !== 'USD') {
        this.querySelector('.xtra-coupon__terms').textContent = 'Enter at checkout. US$50 off once per order; converted at checkout. Cannot combine with other discounts.';
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
    }
    async copy() {
      let copied = false;
      try {
        await navigator.clipboard.writeText(this.dataset.code);
        copied = true;
      } catch (_) {
        const field = document.createElement('textarea');
        field.value = this.dataset.code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;top:0;left:-9999px;';
        document.body.append(field);
        field.select();
        try { copied = document.execCommand('copy'); } catch (_) { /* Manual selection stays available. */ }
        field.remove();
        this.button.focus({preventScroll:true});
      }
      if (!this.isConnected) return;
      clearTimeout(this.timer);
      this.button.textContent = copied ? 'Copied' : 'Copy code';
      this.status.textContent = copied ? `Code ${this.dataset.code} copied.` : 'Copy unavailable. Select and copy the code shown next to this button.';
      this.status.classList.toggle('xtra-coupon__status--error', !copied);
      this.timer = setTimeout(() => {this.button.textContent = 'Copy code';}, 2200);
    }
  });
})();
